import {
    ADMIN_ACCESS,
    MAP,
    PASSENGERS_ACCESS,
    CATALOG_ACCESS,
    CATALOG_DELETE_ACCESS,
    CATALOG_ACCESS_READONLY,
    JOURNALING,
    PASSENGERS_SETTINGS_ACCESS,
    CATALOG_SETTINGS_ACCESS,
    VIDEO_SETTINGS_ACCESS,
    NAVIGATION_SETTINGS_ACCESS,
    JOURNALS_SETTINGS_ACCESS,
    BC_SETTINGS_ACCESS,
    USER_ADD_ACCESS,
    USER_DELETE_ACCESS,
    USER_VIEW_ACCESS,
    VIDEO_ADD_ACCESS,
    VIDEO_DELETE_ACCESS,
    VIDEO_DELETE_MY_ACCESS,
    VIDEO_VIEW_ACCESS,
    VEHICLE_DIAGNOSTIC_ACCESS,
    BC_RESULT_ACCESS,
    BC_ACCESS,
    REMOTE_UPDATE_ACCESS,
    TICKETS_VALIDATION_ACCESS,
    ADAS_ACCESS,
    PDM_VIEW_ACCESS,
    PDM_TREE_UPDATE_ACCESS,
    permissionsCode,
} from 'shared/consts/permissions';

import { IModulesConfigurations } from './configurationTypes';

export const configuration: IModulesConfigurations = {
    permissions: {
        [ADMIN_ACCESS]: 'Администрирование',
        [CATALOG_SETTINGS_ACCESS]: 'Доступ к настройкам справочников',
        [USER_ADD_ACCESS]: 'Добавление/редактирование пользователей и ролей',
        [USER_DELETE_ACCESS]: 'Удаление пользователей и ролей',
        [USER_VIEW_ACCESS]: 'Просмотр пользователей и ролей',
    },
    modules: [
        {
            title: 'Карта',
            module: 'map',
            enable: true,
            permissions: {
                [MAP]: 'Просмотр данных на карте',
            }
        },
        {
            title: 'Видео', module: 'video', enable: true,
            sections: [
                { title: 'Потоковое видео с ТС', section: 'online', enable: true },
                { title: 'Видео с ТС по заявкам', section: 'requests', enable: true },
                { title: 'Архив видео', section: 'archive', enable: true },
                { title: 'Мои заявки', section: 'myrequests', enable: true },
                { title: 'Мониторинг архива на ТС', section: 'vehicle-archive-monitoring', enable: false },
            ],
            permissions: {
                [VIDEO_ADD_ACCESS]: 'Добавление/редактирование видео',
                [VIDEO_DELETE_ACCESS]: 'Удаление заявок в Архиве видео',
                [VIDEO_DELETE_MY_ACCESS]: 'Удаление заявок в Мои заявки',
                [VIDEO_VIEW_ACCESS]: 'Просмотр видео',
            }
        },
        {
            title: 'Пассажиропоток', module: 'passengers', enable: true,
            sections: [
                { title: 'Текущие данные', section: 'analysis', enable: true },
                { title: 'Реестр обследований', section: 'registry', enable: false },
                { title: 'Рейсы', section: 'passage', enable: true },
                { title: 'Остановочные пункты', section: 'stops', enable: true },
                { title: 'Оплата по рейсам', section: 'pay', enable: true },
                { title: 'Межостановочные/межрайонные корреспонденции', section: 'correspondence', enable: false },
                { title: 'Пассажирооборот маршрута', section: 'passturn', enable: true },
                { title: 'Пассажирооборот ОП', section: 'turnstops', enable: true },
                { title: 'Нагрузка на ТС на перегонах', section: 'betweenstops', enable: true },
                { title: 'Потребное количество подвижного состава', section: 'rolling-stock', enable: true },
                { title: 'Перераспределение подвижного состава', section: 'dist-rolling-stock', enable: true },
                { title: 'Отчёты по пассажиропотоку', section: 'reports', enable: true },
                { title: 'Ежедневные данные (new)', section: 'daily-data', enable: false },
            ],
            permissions: {
                [PASSENGERS_ACCESS]: 'Доступ к подсистеме "Пассажиропоток"',
            }
        },
        {
            title: 'Проведение билетного контроля', module: 'bc', enable: false,
            sections: [
                { title: 'Производственный календарь', section: 'calendar', enable: true },
                { title: 'Наряд-задания', section: 'controllertask', enable: true },
                { title: 'Рейтинги маршрутов', section: 'routerate', enable: true },
                { title: 'Текущий процесс контроля', section: 'departmentcontroll', enable: true },
                { title: 'Результаты ПБК', section: 'resultuser', enable: true },
                { title: 'Отчеты по ПБК', section: 'reports', enable: true },
                { title: '', section: 'result', enable: true },
            ],
            permissions: {
                [BC_RESULT_ACCESS]: 'Результаты ПБК',
                [BC_ACCESS]: 'ПБК',
            }
        },
        {
            title: 'Импорт данных', module: 'import-data', enable: true,
            sections: [
                { title: 'Импорт данных о валидациях проездных билетов', section: 'tickets-validation', enable: true },
            ],
            permissions: {
                [TICKETS_VALIDATION_ACCESS]: 'Импорт данных о валидациях проездных билетов',
                [CATALOG_ACCESS]: 'Добавление/редактирование данных в справочниках',
            }
        },
        {
            title: 'Удаленное обновление', module: 'mnt-configuration', enable: true,
            sections: [
                { title: 'Конфигурации МНТ', section: 'configurations', enable: true },
                { title: 'Группа конфигурации', section: 'configuration', enable: true },
                { title: 'Состояние ТС', section: 'vehicle-groups', enable: true },
            ],
            permissions: {
                [REMOTE_UPDATE_ACCESS]: 'Удаленное обновление',
            }
        },
        { title: 'Сведения о выпуске', module: 'vehicle-work-data', enable: false, },
        {
            title: 'Система мониторинга состояния водителя',
            module: 'smsv',
            enable: false,
        },
        {
            title: 'Мониторинг бортового оборудования', module: 'vehicle-diagnostic', enable: true,
            sections: [
                { title: 'Текущее состояние БО', section: 'current', enable: true },
                { title: 'Анализ работы АСМПП', section: 'asmpp', enable: false },
                { title: 'Анализ работоспособности оборудования СМСВ', section: 'eqnt-perf-analysis-smsv', enable: false },
                { title: 'Анализ температурного режима в ТС', section: 'temperature-sensors-analysis', enable: false },
            ],
            permissions: {
                [VEHICLE_DIAGNOSTIC_ACCESS]: 'Просмотр мониторинга бортового оборудования'
            } 
        },
        {
            title: 'ПДМ', module: 'pdm', enable: false,
            sections: [
                {
                    title:   'Тепловая карта',
                    section: 'pdm-heatmap',
                    enable:  true,
                },
                {
                    title:   'Редактор уникальных деревьев датчиков',
                    section: 'tree-editor',
                    enable:  true,
                    permissions: {
                        [PDM_VIEW_ACCESS]: permissionsCode[PDM_VIEW_ACCESS],
                        [PDM_TREE_UPDATE_ACCESS]: permissionsCode[PDM_TREE_UPDATE_ACCESS],
                    }
                },
                {
                    title:   'Мониторинг состояния БО',
                    section: 'pdm-vehicle-diagnostic-report',
                    enable:  true,
                },
                {
                    title:   'Журнал изменений состояния узла',
                    section: 'change-node-journal',
                    enable:  true,
                },
                { 
                    title: 'Графики', 
                    section:'charts', 
                    enable: false 
                },
            ],
            permissions: {
                [PDM_VIEW_ACCESS]: permissionsCode[PDM_VIEW_ACCESS],
            }
        },
        {
            title: 'Отчеты ИСПВ', module: 'adas', enable: false,
            sections: [
                { title: 'Количество и динамика инцидентов', section: 'incidents-dynamic', enable: true },
                { title: 'Распределение инциндентов по маршруту', section: 'incidents-distribution', enable: true },
                { title: 'Детализация инцидентов по ТС', section: 'incidents-detailing', enable: true },
            ],
            permissions: {
                [ADAS_ACCESS]: permissionsCode[ADAS_ACCESS],
            }
        },
        {
            title: 'Оценка вождения',
            module: 'driving-assessment',
            enable: false,
        },
        {
            title: 'Настройки системы', module: 'system', enable: true,
            sections: [
                {
                    title: 'Подсистема навигации',
                    section: 'navigation',
                    enable: true,
                    permissions: {
                        [NAVIGATION_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Навигация"',
                    }
                },
                {
                    title: 'Подсистема доступа к видео',
                    section: 'video',
                    enable: true,
                    permissions: {
                        [VIDEO_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Видео"',
                    }
                },
                {
                    title: 'Подсистема анализа пассажиропотока',
                    section: 'passengers',
                    enable: true,
                    permissions: {
                        [PASSENGERS_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Пассажиропоток"',
                    }
                },
                {
                    title: 'Подсистема журналирования',
                    section: 'journals',
                    enable: true,
                    permissions: {
                        [JOURNALS_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Журналы"',
                    }
                },
                {
                    title: 'Подсистема ПБК',
                    section: 'bc',
                    enable: false,
                    permissions: {
                        [BC_SETTINGS_ACCESS]: 'Доступ к настройкам билетного контроля',
                    }
                },
                {
                    title: 'Настройка параметров импорта данных из ВИС',
                    section: 'eis',
                    enable: false,
                    permissions: {
                        [CATALOG_SETTINGS_ACCESS]: 'Доступ к настройкам справочников',
                    }
                },
                {
                    title: 'Датчики температуры',
                    section: 'temperatureSensors',
                    enable: false,
                },
                {
                    title: 'Настройки мониторинга тревожной сигнализации',
                    section: 'alarmSystem',
                    enable: false,
                },
                {
                    title: 'Система мониторинга состояния водителя',
                    section: 'smsv',
                    enable: false,
                },
            ]
        },
        {
            title: 'Справочники', module: 'handbooks', enable: true,
            sections: [
                { title: 'Предприятия перевозчиков', section: 'agency', enable: true },
                { title: 'Филиалы', section: 'park', enable: true },
                { title: 'Сотрудники', section: 'driver', enable: true },
                { title: 'Типы МНТ', section: 'edevmnttype', enable: true },
                { title: 'МНТ', section: 'devmnt', enable: true },
                { title: 'Устройства подсчёта пассажиров', section: 'passpotok', enable: false },
                { title: 'GSM-модемы', section: 'devgsm', enable: false },
                { title: 'Видеорегистраторы', section: 'devdvr', enable: true },
                { title: 'Типы видеокамер', section: 'typecamera', enable: true },
                { title: 'Видеокамеры', section: 'devcamera', enable: false },
                { title: 'Типы транспортных средств', section: 'transporttype', enable: true },
                { title: 'Типы вместимости ТС', section: 'capacitytype', enable: true },
                { title: 'Транспортные средства', section: 'vehicle', enable: true },
                { title: 'Остановочные пункты', section: 'stop', enable: true },
                { title: 'Виды сообщений', section: 'marshtype', enable: true },
                { title: 'Маршруты', section: 'route', enable: true },
                { title: 'Варианты маршрутов', section: 'sroutevars', enable: true },
                { title: 'Рейсы', section: 'rtrip', enable: true },
                { title: 'Последовательность остановок в рейсах', section: 'tripstops', enable: true },
                { title: 'Праздничные дни', section: 'holidays', enable: true },
                { title: 'Варианты расписаний', section: 'raspvariants', enable: true },
                { title: 'Плановые времена отправлений по ОП', section: 'rasptime', enable: true },
                { title: 'Назначение ТС на маршрут', section: 'svehicletask', enable: true },
                { title: 'Замены ТС на маршруте', section: 'replacevehicle', enable: true },
                { title: 'Устройства контроля оплаты', section: 'validator', enable: false },
                { title: 'Муниципальные районы', section: 'district', enable: false },
                { title: 'Территориальные отделы', section: 'department', enable: false },
                { title: 'Районы контроля', section: 'controlregion', enable: false },
                { title: 'Модели оборудования сотрудников', section: 'vcontrollerequipmenttype', enable: false },
                { title: 'Оборудование сотрудников', section: 'controllerequipment', enable: false },
                { title: 'Служебные карты контролёра', section: 'controllercard', enable: false },
                { title: 'Виды билетов', section: 'ticketview', enable: true },
                { title: 'Типы билетов', section: 'tickettype', enable: true },
                { title: 'Связь маршрутов, рейсов и остановочных пунктов', section: 'racestops', enable: true },
                { title: 'Связь вариантов расписаний и плановых отправлений по ОП', section: 'stimevars', enable: true },
                { title: 'Типы графиков работы', section: 'graphictype', enable: false },
                { title: 'Типы инцидентов', section: 'incidents', enable: false },
                { title: 'Типы видеорегистраторов', section: 'dvrtypes', enable: true },
                { title: 'Геозоны', section: 'geozonesdm', enable: false },
                { title: 'ТС-водитель', section: 'vehdrivers', enable: false },
                { title: 'Ограничения для показаний акселерометра', section: 'accelerometerParams', enable: false },
                { title: 'Ограничения скорости', section: 'speedLimit', enable: false },
                { title: 'Группы', section: 'dqagroups', enable: false },
                { title: 'Модели ТС', section: 'vehiclemodel', enable: false },
                { title: 'Модели датчиков АСМПП', section: 'asmppsensormodel', enable: false },
                { title: 'Типы датчиков температуры', section: 'devtempsenstypes', enable: false },
                { title: 'ИСПВ', section: 'ispv', enable: false },
                { title: 'BLE-метки', section: 'blemarkslist', enable: false },
                { title: 'Типы BLE-меток', section: 'blemarkstypes', enable: false },
                { title: 'Параметры BLE-меток', section: 'blemarksparameters', enable: false },
                { title: 'Референсные значения RSSI', section: 'blemarkssettings', enable: false },
                { title: 'Реестр идентификаторов BLE-меток', section: 'blemarksidentifierregistry', enable: false },
                { title: 'Парки', section: 'garages', enable: false },
                { title: 'Колонны', section: 'garagecolumns', enable: false },
            ],
            permissions: {
                [CATALOG_ACCESS]: 'Добавление/редактирование данных в справочниках',
                // [CATALOG_EDIT_ACCESS]: "Редактирование данных в справочниках",
                [CATALOG_DELETE_ACCESS]: 'Удаление данных из справочников',
                [CATALOG_ACCESS_READONLY]: 'Просмотр справочников',
            }
        },
        {
            title: 'Журналы', module: 'journal', enable: true,
            sections: [
                { title: 'Журнал действий пользователя', section: 'useractions', enable: true },
                { title: 'Журнал событий ТС', section: 'eventsts', enable: true },
                { title: 'Журнал событий ПО', section: 'eventspo', enable: true },
                { title: 'Журнал событий видео', section: 'video', enable: true },
                { title: 'Журнал инцидентов ИСПВ', section: 'adas', enable: false },
            ],
            permissions: {
                [JOURNALING]: 'Доступ к подсистеме "Журналирование"',
            }
        },
        {
            title: 'Администрирование', module: 'admin', enable: true,
            sections: [
                { title: 'Пользователи', section: 'users', enable: true },
                { title: 'Роли', section: 'roles', enable: true },
            ]
        },
    ],
    aboutPage: {
        sectionsList: [
            {
                module: 'map',
                title: 'Карта с указанием ТС и справочной информацией',
                enable: true
            },
            {
                module: 'video',
                title: 'Видео с ТС и архив заявок',
                enable: true
            },
            {
                module: 'passengers',
                title: 'Пассажиропоток с количественными и аналитическими показателями перевозки пассажиров',
                enable: true
            },
            {
                module: 'bc',
                title: 'Проведение билетного контроля с отчетами по результатам проверок',
                enable: false
            },
            {
                module: 'vehicle-diagnostic',
                title: 'Мониторинг бортового оборудования с актуальной информацией о состоянии ТС',
                enable: true
            },
            {
                module: 'handbooks',
                title: 'Справочники с данными о ТС, маршрутах и сотрудниках',
                enable: true
            },
            {
                module: 'journal',
                title: 'Журналы действий ПО, ТС и пользователей',
                enable: true
            }
        ],
        manualList: [
            {
                name: 'rukovodstvo-administratora.pdf',
                title: 'Руководство администратора',
                version: '1.30',
                enable: true,
            },
            {
                name: 'rukovodstvo-operatora.pdf',
                title: 'Руководство оператора',
                version: '1.30',
                enable: true,
            }
        ]
    }

}
